<template>
  <img
    class="ImageWebp"
    :style="styleName"
    :class="className"
    :src="newSrc"
    :alt="alt"
    :srcset="srcset"
    :width="width"
    @error="$emit('error', $event)"
    @load="$emit('load', $event)"
    @click="$emit('click', $event)"
  />
</template>

<script>
import { isWebpSupported, getImgUrl } from '@/utils/imageUtils'

/** 可以将公司内部图片转成webp格式地址，减少网络流量，提升图片加载速度 */
export default {
  name: 'ImageWebp',
  props: {
    /** String 图片资源地址: */
    src: {
      type: String,
      default: ''
    },   
    alt: {
      type: String,
      default: ''
    },
    srcset: {
      type: String,
      default: ''
    },
    styleName: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    /** Number 图片宽度，默认 300px */
    width: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      newSrc: ''
    }
  },
  watch: {
    src: {
      handler(src) {
        this.newSrc = getImgUrl(src, this.width)
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.ImageWebp {
  width: 100%;
  height: 100%;
  border-radius: inherit;
}
</style>